import {MDB} from "../MDB";
import {IBorcluTakbisSorgulamaSonuc} from "../uyap/BorcluTakbisSorgulama";
import HacizInjectable from "./HacizInjectable";
import {IIcraDosyasiSonuc} from "../uyap/BorcluIcraDosyasi";
import {HacizEvrakTypeEnum} from "../uyap/enum/HacizEvrakTypeEnum";
import TakipDosya from "@/plugins/uyap-plugin/uyap/classes/TakipDosya";
import {ISgkHacizSonuc} from "@/plugins/uyap-plugin/uyap/BorcluSgkHaciz";

const mdb = new MDB();

export default class HacizController extends HacizInjectable {
    constructor(borclu: any, dosya: TakipDosya) {
        super(borclu, dosya);
    }

    // TODO: dosya id sıkıntı çıkarabilir tekrardan istek atıp eşitlemek gerekebilir
    alacakliOlduguDosyaEkle(kayitliDosya: IIcraDosyasiSonuc) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.ALACAKLI_OLDUGU_DOSYA);
        let talepObj = Object.assign({}, obj, {
            "sorguId": "0",
            "dosyaId": kayitliDosya.dosyaId,
            "kisiKurumId": kayitliDosya.guncelKisiKurumId,
            "birimAdi": kayitliDosya.birimAdi,
            "dosyaNo": kayitliDosya.dosyaNo,
            "dosyaTurKod": kayitliDosya.dosyaTurKodu
        });
        this.evrakTutar += obj.talepMasrafi;
        this.talepBilgileri.push(talepObj);
    }

    aracHacizEkle(hacizSerhi: number, plaka: string, plakaYildizli: string) {
        let hacizObj = MDB.haciz.aracHacizParams.find((item: any) => item.value == hacizSerhi);
        if (!hacizObj) {
            hacizObj = MDB.haciz.aracHacizParams[0];
        }
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.ARAC_HACZI);
        let talepObj = Object.assign({}, obj, {
            "sorguId": 0,
            "plaka": plaka,
            "plakaYildizli": plakaYildizli,
            "hacizSerhi": hacizObj.value.toString(),
            "hacizSerhiText": hacizObj.name
        });
        this.evrakTutar += obj.talepMasrafi; //0
        console.log("aracHacizEkle", talepObj);
        this.talepBilgileri.push(talepObj);
    }

    sgkMossipHacizEkle(mossipHaciz: ISgkHacizSonuc) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.SGK_MOSSIP_HACZI);
        let talepObj = Object.assign({}, obj, {
            fields: [
                {
                    "id": "kurumAdi",
                    "title": "Kurum Adı"
                }
            ],
            kurumAdi: mossipHaciz.kisiTipString,
            sorguId: 0,
            masraf:0,
            id:0
        });
        this.evrakTutar += obj.talepMasrafi;
        console.log("sgkMossipHacizEkle - talep eklendi:", talepObj);
        this.talepBilgileri.push(talepObj);
    }

    bankaHacizEkle() {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.BANKA_HACZI);
        let hesapList = this.borcluBloc.haciz.bankaHesapHacziParams.hesapList;
        let talepObj = Object.assign({}, obj, {
            "dosyaId": this.dosyaBloc.dosyaId,
            "tarafList": "",    // boş gidiyor
            "bankaList": this.borcluBloc.haciz.bankaHesapHacziParams.bankaList.map(b => b.ilgiliKisiIlkKisiKurumId).join(','),
            "bankaListStr": this.borcluBloc.haciz.bankaHesapHacziParams.bankaList.map(b => b.ilgili).join(', '),
            "hesapList": hesapList.map(value => value.tktId).join(','),
            "hesapListStr":hesapList.map(value => value.aciklama).join(','),
            "evrakAdi": this.borcluBloc.haciz.bankaHesapHacziParams.evrakAdi,
            "haricAdi": this.borcluBloc.haciz.bankaHesapHacziParams.haricAdi,
            "evrakAdiSTR": this.borcluBloc.haciz.bankaHesapHacziParams.evrakAdiSTR,
            "haricAdiSTR": this.borcluBloc.haciz.bankaHesapHacziParams.haricAdiSTR,
            "masraf": obj.talepMasrafi * this.borcluBloc.haciz.bankaHesapHacziParams.bankaList.length,
            "fields": [
                {
                    "id": "bankaListStr",
                    "title": "Banka Listesi"
                },
                {
                    "id": "hesapListStr",
                    "title": "Hesap Listesi"
                },
                {
                    "id": "evrakAdiSTR",
                    "title": "Evrak"
                },
                {
                    "id": "haricAdiSTR",
                    "title": "Haciz"
                }
            ],
            "id":0
        });
        if (this.borcluBloc.haciz.bankaHesapHacziParams.evrakAdi == "IHB_3" || this.borcluBloc.haciz.bankaHesapHacziParams.evrakAdi == "IHB_2") {
            talepObj["tebligTarihi"] = this.borcluBloc.haciz.bankaHesapHacziParams.tebligTarihi;
        }
        this.evrakTutar += obj.talepMasrafi * this.borcluBloc.haciz.bankaHesapHacziParams.bankaList.length; //0
        this.talepBilgileri.push(talepObj);
    }

    postaCekiHacziEkle() {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.POSTA_CEKI_HACZI);
        let talepObj = Object.assign({}, obj, {
            "sorguId": "0",
        });
        this.evrakTutar += obj.talepMasrafi;
        this.talepBilgileri.push(talepObj);
    }

    ihbarname89_1Ekle(params: any) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.IHBARNAME_89_1);
        let tebligatMasrafi = (Object.values(mdb.tebligat.turler) as Array<{
            masrafAdi: string;
            fiyati: number;
            postaMasraflariId: number;
        }>).find(tur => tur.postaMasraflariId == params.tebligatTuru)?.fiyati;

        console.log('ihbarname89_1Ekle params:', {
            tebligatTuru: params.tebligatTuru,
            tebligatTuruAciklama: params.tebligatTuruAciklama,
            tebligatMasrafi: tebligatMasrafi,
            fullParams: params
        });

        let talepObj = Object.assign({}, obj,{
            "dosyaId": this.dosyaBloc.dosyaId,
            "kisiKurumId": params.kisiKurumId,
            "tebligatTuru": params.tebligatTuru,
            "tebligatTuruAciklama": params.tebligatTuruAciklama,
            "masraf": tebligatMasrafi,
            "adresTuru": params.adresTuru,
            "adresTuruAciklama": params.adresTuruAciklama,
            "adres": params.adres,
            "tarafList": params.tarafList,
            "fields": [
                {
                    "id": "tebligatTuruAciklama",
                    "title": "Tebligat Türü"
                },
                {
                    "id": "adresTuruAciklama",
                    "title": "Adres Türü"
                },
                {
                    "id": "adres",
                    "title": "Adres"
                }
            ],
            "id": 0
        });

        this.evrakTutar += (talepObj.talepMasrafi + tebligatMasrafi);
        this.talepBilgileri.push(talepObj);
    }

    ihbarname89_2Ekle(params: any) {
        let talepObj = {
            "grupKodu": 0,
            "talepKodu": 43,
            "talepAdi": "89-2 İhbarname Talebi",
            "talepKisaAdi": "89-2 İhbarname Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalep89_2DVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A",
            "sorguId": "",
            "tebligTarihi": params.tebligTarihi,
            "dosyaId": this.dosyaBloc.dosyaId,
            "kisiKurumId": params.kisiKurumId,
            "tebligatTuru": params.tebligatTuru,
            "tebligatTuruAciklama": params.tebligatTuruAciklama,
            "adresTuru": params.adresTuru,
            "adresTuruAciklama": params.adresTuruAciklama,
            "adres": params.adres,
            "tarafList": params.tarafList
        }
        this.evrakTutar += talepObj.talepMasrafi;
        this.talepBilgileri.push(talepObj);
    }

    ihbarname89_3Ekle(params: any) {
        let talepObj = {
            "grupKodu": 0,
            "talepKodu": 44,
            "talepAdi": "89-3 İhbarname Talebi",
            "talepKisaAdi": "89-3 İhbarname Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalep89_3DVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A",
            "sorguId": "",
            "tebligTarihi": params.tebligTarihi,
            "dosyaId": this.dosyaBloc.dosyaId,
            "kisiKurumId": params.kisiKurumId,
            "tebligatTuru": params.tebligatTuru,
            "tebligatTuruAciklama": params.tebligatTuruAciklama,
            "adresTuru": params.adresTuru,
            "adresTuruAciklama": params.adresTuruAciklama,
            "adres": params.adres,
            "tarafList": params.tarafList
        }
        this.evrakTutar += talepObj.talepMasrafi;
        this.talepBilgileri.push(talepObj);
    }

    tasinmazHacizEkle(tasinmaz: IBorcluTakbisSorgulamaSonuc) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == "AvukatTalepGayrimenkulHacziDVO");
        let talepObj = Object.assign({}, obj, {
            "tasinmazId": tasinmaz.tasinmazDVO.tasinmazId,
            "sorguId": 0,
            "il": tasinmaz.tasinmazDVO.il,
            "ilce": tasinmaz.tasinmazDVO.ilce,
            "mahalle": tasinmaz.tasinmazDVO.mahalle,
            "ada": tasinmaz.tasinmazDVO.ada,
            "parsel": tasinmaz.tasinmazDVO.parsel,
        });
        this.evrakTutar += obj.talepMasrafi; //0
        this.talepBilgileri.push(talepObj);
    }

    tasinirHacizTalimatiEkle(params: any) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.TASINIR_HACIZ_TALIMATI);
        let talepObj = Object.assign({}, obj, {
            "sorguId": "",
            "birimId": params.birimId,
            "birimAdi": params.birimAdi,
            "aciklama": params.aciklama,
            "tarafList": ""
        });
        this.evrakTutar += obj.talepMasrafi; //0
        this.talepBilgileri.push(talepObj);
    }

    tasinirHacizEkle(aciklama: string) {
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.TASINIR_HACZI);
        let talepObj = Object.assign({}, obj, {
            "sorguId": "",
            "aciklama": aciklama
        });
        this.evrakTutar += obj.talepMasrafi; //0
        this.talepBilgileri.push(talepObj);
    }

    maasHacizEkle(params: any) {
        let calismaDurumuObj = MDB.haciz.maasHacizParams.find((i: any) => i.value == params.calismaDurumu);
        if (!calismaDurumuObj) {
            calismaDurumuObj = MDB.haciz.maasHacizParams[0];
        }
        let obj = mdb.hacizEvrakTipleri.find((i: any) => i.className == HacizEvrakTypeEnum.MAAS_HACZI);
        params.nafakaTutari = String(params.nafakaTutari);
        params.nafakaTutari = params.nafakaTutari.replace('.', ',');
        let talepObj = Object.assign({}, obj, {
            "masraf": obj.talepMasrafi,
            "kurumId": params.kurumId,
            "kurumAdi": params.kurumAdi,
            "calismaDurumu": calismaDurumuObj.value.toString(),
            "calismaDurumuText": calismaDurumuObj.name,
            "maasininBirBoluDordu": !!params.maasininBirBoluDordu,
            "alacaklarininTamami": !!params.alacaklarininTamami,
            "emekliIkramiyeHaczi": !!params.emekliIkramiyeHaczi,
            "nafaka": !!params.nafaka,
            "nafakaTutari": (!params.nafaka ? '' : params.nafakaTutari),
            "aciklama": params.aciklama,
            "fields": [
                {
                    "id": "kurumAdi",
                    "title": "Kurum Adı"
                },
                {
                    "id": "calismaDurumuText",
                    "title": "Çalışma Durumu"
                },
                {
                    "id": "maasininBirBoluDordu",
                    "title": "Maaşının 1/4 ü"
                },
                {
                    "id": "alacaklarininTamami",
                    "title": "Tazminatlarının, Sosyal Hak ve Alacaklarının Tamamı"
                },
                {
                    "id": "emekliIkramiyeHaczi",
                    "title": "Emekli İkramiyesinin Haczi"
                },
                {
                    "id": "nafakaTutari",
                    "title": "Nafaka İse Aylık Nafaka Tutarı"
                },
                {
                    "id": "aciklama",
                    "title": "Açıklama"
                }
            ],
            "iconGosterilecekAlanlar": [
                "maasininBirBoluDordu",
                "alacaklarininTamami",
                "emekliIkramiyeHaczi"
            ],
            "moneyFormatlanacaklar": [
                "nafakaTutari"
            ],
            "id": 0
        });
        this.evrakTutar += obj.talepMasrafi; //0
        this.talepBilgileri.push(talepObj);
    }

}
